import { environment } from '../models/environment';
import { TSqEnvironment } from '../models/tsq-environment.model';

export function getTSqEnvironment(): TSqEnvironment {
  return environment as unknown as TSqEnvironment;
}
